import request from '@/utils/request'

//获取课程笔记列表
export function notelist (data) {
	return request({
		url: '/api/note/list',
		method: 'get',
		params: data
	})
}

//发布笔记
export function notePublish(data) {
	return request({
		url: '/api/note/add',
		method: 'post',
		data
	})
}

//删除课程笔记
export function noteRemove(data) {
	return request({
		url: '/api/note/remove/'+data.noteId,
		method: 'post',
		data
	})
}
//更新课程笔记
export function noteUpdate(data) {
	return request({
		url: '/api/note/update',
		method: 'post',
		data
	})
}

//我的笔记
export function mynoteList(data) {
	return request({
		url: '/api/note/my',
		method: 'get',
		params: data
	})
} 

